export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              投稿爆料
            </h2>
            <p className="text-sm text-foreground-500">有猛料想分享？我们在此等你</p>
          </div>
          <div className="bg-background-100 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-send-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">邮箱投稿</h3>
                <p className="text-xs text-foreground-500">tips@chigua.example.com</p>
                <p className="text-xs text-foreground-400 mt-1">24小时内审核回复</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">微信投稿</h3>
                <p className="text-xs text-foreground-500">公众号：吃瓜黑料爆料</p>
                <p className="text-xs text-foreground-400 mt-1">后台发送「爆料」获取指引</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 mb-1">侵权投诉</h3>
                <p className="text-xs text-foreground-500">legal@chigua.example.com</p>
                <p className="text-xs text-foreground-400 mt-1">48小时内核实处理</p>
              </div>
            </div>
            <div className="mt-8 p-4 bg-primary-50 rounded-xl text-center">
              <p className="text-xs text-primary-700">
                <i className="ri-information-line mr-1"></i>
                我们承诺严格保护每一位爆料者隐私，采用多层匿名加密，绝不透露爆料者身份信息
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}